import { createStyles, makeStyles } from "@material-ui/core";
const FTLSelectStyles = makeStyles((theme) => createStyles({
    checkboxWrapper: {
        display: "flex",
        alignItems: "center",
        padding: "0 12px",
        minHeight: 32,
        fontSize: "14px",
        lineHeight: "20px",
        width: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    detail: {
        flexGrow: 0,
        flexShrink: 1,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: theme.palette.text.tertiary,
        marginLeft: "auto",
    },
    option: ({ showCheckboxes, }) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#fff",
        border: "none",
        cursor: "pointer",
        outline: "none",
        padding: showCheckboxes ? 0 : "6px 12px",
        minHeight: 32,
        boxSizing: "border-box",
        "&:hover, &:focus, &[data-focus='true']": {
            backgroundColor: "rgba(3, 10, 22, 0.04)",
        },
        "&[aria-selected='true']": {
            background: "rgba(3, 11, 22, 0.08)",
        },
    }),
    optionText: Object.assign(Object.assign({}, theme.typography.listItemText), { color: theme.palette.text.primary, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }),
    listWrapper: {
        position: "relative",
        padding: "8px 0",
    },
    noDataWrapper: Object.assign(Object.assign({ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }, theme.typography.listItemText), { color: theme.palette.text.secondary, minHeight: 32, boxSizing: "border-box", padding: "6px 12px" }),
    listSearch: {
        padding: "8px 0",
    },
    hidden: {
        display: "none",
    },
}));
export default FTLSelectStyles;
//# sourceMappingURL=FTLSelectStyles.styles.js.map